import AOS from "aos";
import lozad from "lozad";
import { setBackgroundElement, detectCloseElement, buttonToTop, clickScrollToDiv, appendCaptchaASP, ToggleItem } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	fakeScrollBar();
	sectionHomeHow();
	buttonToTop();
	ToggleItem();
	// About
	sectionAboutWhatWeDo();
	// $('.select2').select2();
	// product
	productShowMore();
});
/*==================== Product - Show More Content ====================*/
function productShowMore() {
	const textInitialShow = $(".section-product-common .item-box-primary .btn-show-more").data("text-show");
	const textInitialLess = $(".section-product-common .item-box-primary .btn-show-more").data("text-less");
	$(".section-product-common .item-box-primary .btn-show-more").on("click", function () {
		const $item = $(this).closest(".item-box-primary");
		if ($(this).hasClass("active")) {
			$item.find(".desc").addClass("line-clamp-3");
			$(this).find("span").text(textInitialShow);
		} else {
			$item.find(".desc").removeClass("line-clamp-3");
			$(this).find("span").text(textInitialLess);
		}
		$(this).toggleClass("active");
	});
}
/*==================== About - What we do ====================*/
function sectionAboutWhatWeDo() {
	$(".section-about-what-we-do .title").on("click", function () {
		const indexValue = $(this).parent().data("index");
		$(`.section-about-what-we-do .item-image[data-index="${indexValue}"]`).toggleClass("active").siblings().removeClass("active");
	});
}
/*==================== Home-how ====================*/
function sectionHomeHow() {
	const $wrapHowItWorks = $(".section-home-how .scroll-wrap");
	const initialHeight = Array.from($(".section-home-how .col").slice(0, 3)).reduce((acc, item) => {
		return acc + $(item).outerHeight() + $(item).css("margin-bottom").replace("px", "") * 1;
	}, 0);
	$wrapHowItWorks.css("max-height", initialHeight + "px");
}

/*==================== Fake Scroll Bar ====================*/
function fakeScrollBar() {
	const $scrollWrap = $(".scroll-wrap");
	const $wrapHowItWorks = $(".wrap-how-it-works");
	const $fakeScroll = $(".fake-scroll");
	const $fakeScrollBar = $(".fake-scroll-bar");

	function updateFakeScroll() {
		const scrollHeight = $wrapHowItWorks.height();
		const visibleHeight = $scrollWrap.height();
		const scrollRatio = visibleHeight / scrollHeight;

		if (scrollRatio >= 1) {
			const fakeScrollHeight = $fakeScroll.height();
			const scrollBarHeight = fakeScrollHeight * scrollRatio;
			$fakeScrollBar.height(scrollBarHeight);
		} else {
			$fakeScroll.show();
			const fakeScrollHeight = $fakeScroll.height();
			const scrollBarHeight = fakeScrollHeight * scrollRatio;
			$fakeScrollBar.height(scrollBarHeight);

			const scrollTop = $scrollWrap.scrollTop();
			const maxScroll = scrollHeight - visibleHeight;
			const scrollPercentage = scrollTop / maxScroll;
			const fakeScrollTop = (fakeScrollHeight - scrollBarHeight) * scrollPercentage;

			$fakeScrollBar.css("top", fakeScrollTop + "px");
		}
	}
	$scrollWrap.on("scroll", updateFakeScroll);
	$(window).on("resize", updateFakeScroll);

	// Initial update
	updateFakeScroll();

	// Make the fake scroll bar draggable
	$fakeScrollBar.draggable({
		containment: "parent",
		axis: "y",
		drag: function (event, ui) {
			const fakeScrollHeight = $fakeScroll.height();
			const scrollBarHeight = $fakeScrollBar.height();
			const availableScroll = fakeScrollHeight - scrollBarHeight;
			const scrollPercentage = ui.position.top / availableScroll;

			const scrollHeight = $wrapHowItWorks.height();
			const visibleHeight = $scrollWrap.height();
			const maxScroll = scrollHeight - visibleHeight;

			const newScrollTop = maxScroll * scrollPercentage;
			$scrollWrap.scrollTop(newScrollTop);
		},
	});
}

/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
window.lozadObserver = observer;
